/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Данные по фотографии продукта.
 */
export interface PhotoDataLoyaltyView { 
    /**
     * ID фотографии.
     */
    id: string;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    /**
     * Признак обложки.
     */
    isCover?: boolean;
    /**
     * Наименование файла.
     */
    name?: string;
}

